import React, { memo, useRef } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'


const OtherData = memo(({
    position,
    handleChangePositionByKey,
    formErrors,
    index,
}) => {
    const ref = useRef()
    const { t } = useTranslation()
    const handleChange = (e) => {
        const { target } = e
        e.preventDefault()
        switch (target.name) {
            /*case "businessPartnerContingentBalanceAction":
                handleChangePositionByKey(position.id, target.name, target.checked ? "toBeUpdated" : "none")
                break;*/
            default:
                if (target.type === "checkbox") {
                    handleChangePositionByKey(position.id, target.name, target.checked)
                }
                else {
                    handleChangePositionByKey(position.id, target.name, target.value)
                }
                break;
        }
    }
    const fieldIsDisabled = (name) => {
        let disabled = false
        switch (name) {
            case 'hasDefect':
            case 'hasDefectComment':
            case 'businessPartnerContingentBalanceAction':
            case 'creditContingent':
            case 'creditPoints':
                disabled = position.metaProperties && position.metaProperties.find(metaProp => (metaProp.pointer === `/${name}` && metaProp.attributes === 'isReadOnly'))
                break
            default:
                break
        }
        return !!disabled
    }
    return (
        <div ref={ref}>
            <div className="spacing-down">
                <Row>
                    <Col sm="6" lg="3">
                        <Form.Group className="mb-3">
                            <Form.Check
                                id={`positions${index}hasDefect`}
                                label={t('complaints:qualityDefect')}
                                type="checkbox"
                                name="hasDefect"
                                onChange={handleChange}
                                checked={position.hasDefect}
                                isInvalid={!!formErrors[`positions${index}hasDefect`]}
                                disabled={fieldIsDisabled('hasDefect')}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formErrors[`positions${index}hasDefect`]}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm="6" lg="3">
                        <Form.Group className="mb-3">
                            <Form.Control
                                as="textarea"
                                placeholder=""
                                id={`positions${index}hasDefectComment`}
                                value={position.hasDefectComment}
                                onChange={handleChange}
                                name="hasDefectComment"
                                disabled={!position.hasDefect || fieldIsDisabled('hasDefect')}
                                isInvalid={!!formErrors[`positions${index}hasDefectComment`]}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formErrors[`positions${index}hasDefectComment`]}
                            </Form.Control.Feedback>
                        </Form.Group >
                    </Col>
                </Row>
                <Row>
                    <Col sm="6" lg="3">
                        {position.creditContingent != null &&
                            <Form.Group className="mb-3">
                                <Form.Check
                                    id={`positions${index}creditContingent`}
                                    label={t('returnsProcessingPage:creditToContingent')}
                                    type="checkbox"
                                    name="creditContingent"
                                    onChange={handleChange}
                                    checked={position.creditContingent}
                                    disabled={fieldIsDisabled('creditContingent')}
                                    isInvalid={!!formErrors[`positions${index}creditContingent`]}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formErrors[`positions${index}creditContingent`]}
                                </Form.Control.Feedback>
                            </Form.Group>
                        }
                    </Col>
                    <Col sm="6" lg="3">
                        {position.CreditPoints != null &&
                            <Form.Group className="mb-3">
                                <Form.Check
                                    id={`positions${index}creditPoints`}
                                    label={t('returnsProcessingPage:creditToContingentPoints')}
                                    type="checkbox"
                                    name="creditPoints"
                                    onChange={handleChange}
                                    checked={position.creditPoints}
                                    disabled={fieldIsDisabled('creditPoints')}
                                    isInvalid={!!formErrors[`positions${index}creditPoints`]}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formErrors[`positions${index}creditPoints`]}
                                </Form.Control.Feedback>
                            </Form.Group>
                        }
                    </Col>
                </Row>
            </div>
        </div>
    )
})

export default OtherData
